import cloneDeep from 'lodash/cloneDeep';

const {APP_ENV} = process.env;

const trackers = {
  config: {
    vpEventHome: {evn: 'vp_event_home'},
    vpEventFilter: {evn: 'vp_event_filter'},
    vpEventList: {evn: 'vp_event_list'},
    vpEventBukatalksList: {evn: 'vp_event_bukatalks_list'},
    vpEventBukatalksVideo: {evn: 'vp_event_bukatalks_video'},
    vpEventMomentList: {evn: 'vp_event_moment_list'},
    vpEventDetail: {evn: 'vp_event_detail'},
    vpEventBookingForm: {evn: 'vp_event_booking_form'},
    vpEventCompleteBookingForm: {evn: 'vp_event_complete_booking_form'},
    vpEventReview: {evn: 'vp_event_review'},
    vpEventPayment: {evn: 'vp_event_payment'},
    vpEventPurchase: {evn: 'vp_event_purchase'},
    vpEventListEticket: {evn: 'vp_event_list_eticket'},
    vpEventEticketDetail: {evn: 'vp_event_eticket_detail'},
    vpEventCancelBooking: {evn: 'vp_event_cancel_booking'},
  },
  baseParams() {
    return {
      url: window.location.href,
    };
  },
};

const createTracker = () => {
  const tracker = cloneDeep(window.Tracker) || require('@bukalapak/tracker-js').default;
  const baseUrl = APP_ENV === 'production' ? 'https://t.bukalapak.com' : 'https://tracker.preproduction.bukalapak.com';
  tracker.config({
    dev: !['production', 'preproduction'].includes(APP_ENV),
    baseUrl,
  });

  if (!tracker.event) {
    tracker.event = () => {
      console.warn('Tracker not configured properly');
    };
  }

  return tracker;
};

export {trackers, createTracker};
